var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.btnClass,attrs:{"disabled":_vm.poster.submitted},on:{"click":function($event){return _vm.post()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }